import ContentCard from "@/components/feature/ContentCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { getRelated } from "@/utils/content";
import type { ContentItem } from "@/types/content";

export default function RelatedSection({ item }: { item: ContentItem }) {
  const related = getRelated(item, 4);
  if (related.length === 0) return null;

  const isVideo = item.type === "movie" || item.type === "tv";

  return (
    <section className="mt-12 md:mt-16">
      <SectionHeading title="相关推荐" subtitle="根据类型与标签为你精选" />
      {isVideo ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {related.map((entry) => (
            <ContentCard key={entry.id} item={entry} />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {related.map((entry) => (
            <ContentCard key={entry.id} item={entry} layout="wide" />
          ))}
        </div>
      )}
    </section>
  );
}